<template>
<div class="login-page">
  <b-container>
    <b-img class="logo-kelvatek" src="/images/logo/kelvatek-logo.svg" fluid center alt="Kelvatek Camlin group" />
    <h5 class="logo">
      <i class="fas fa-circle text-gray" />
      <span class="text">LineSIGHT</span> Web
      <i class="fas fa-circle text-kelvatek" />
    </h5>
    <Widget class="mx-auto" title="<h3 class='mt-0'>Login</h3>" customHeader>
      <form class="mt" @submit.prevent="login">
        <div class="form-group">
          <input class="form-control no-border" ref="username" v-model="username" required type="text" name="username" placeholder="Username" :class="{ 'is-invalid': submitted && !username }" />
          <div v-show="submitted && !username" class="invalid-feedback">Username is required</div>
        </div>
        <div class="form-group">
          <input class="form-control no-border" ref="password" v-model="password" required type="password" name="password" placeholder="Password" :class="{ 'is-invalid': submitted && !password }" />
          <div v-show="submitted && !password" class="invalid-feedback">Password is required</div>
        </div>
        <div class="clearfix">
          <div class="btn-toolbar float-right">
            <b-button type="submit" size="sm" variant="inverse" :disabled="loggingIn">Login</b-button>
          </div>
        </div>
      </form>
    </Widget>
  </b-container>
  <Footer />
</div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import Footer from '@/components/Footer/Footer';
import {
  mapGetters
} from 'vuex';

export default {
  name: 'LoginPage',
  components: {
    Widget,
    Footer
  },
  data() {
    return {
      username: '',
      password: '',
      submitted: false
    };
  },
  computed: {
    ...mapGetters('authentication', ['authStatus']),
    loggingIn() {
      return this.authStatus.loggingIn;
    }
  },
  methods: {
    login() {
      this.submitted = true;
      const {
        username,
        password
      } = this;

      if (username && password) {
        this.$store.dispatch('authentication/login', {
          username,
          password
        });
      }
    },
  },
  created() {
    // reset login status
    this.$store.dispatch('authentication/logout');
  },
};
</script>

<style src="./Login.scss" lang="scss" scoped />
